export const TIME_DISPLAY_FORMAT = "HH.mm.ss";
